import type { IntlShape, MessageDescriptor } from 'react-intl';
import type { SerializedProfileAsset } from 'fym-shared/src/music24/artistProfile';
import { kindHasPlainCover, sourceLabel } from '../profileAssets';
import { profileMessages as m } from '../profileMessages';
import type { ProfileService } from './ProfileCard';

/** The name, the size line and the service mark of a banner card (design a1). */
export const BANNER_CARDS: Readonly<
  Record<
    'youtubeBanner' | 'facebookCover',
    { name: MessageDescriptor; size: MessageDescriptor; service: ProfileService }
  >
> = {
  youtubeBanner: { name: m.youtubeName, size: m.youtubeSize, service: 'youtube' },
  facebookCover: { name: m.facebookName, size: m.facebookSize, service: 'facebook' },
};

/** The meta line of a made card: the source and the release ("Blurred cover · Swamps"). */
export function cardSourceLine(intl: IntlShape, asset: SerializedProfileAsset): string {
  const source = intl.formatMessage(sourceLabel(asset.source, kindHasPlainCover(asset)));
  return asset.catalogItemTitle === null
    ? source
    : intl.formatMessage(m.metaSource, { source, title: asset.catalogItemTitle });
}
